/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React from 'react';

import { FormSection } from '@fitinsur/components'

import { BrokerRemunerationOtherSection } from '../index';

function RenderSection({
  disableAll,
  formikProps,
  formikRef,
  idProduct,
  idOperation,
  idOperationParent,
  globalQuestionnaire,
  setShowBrokerRemunerationDeductionSection,
  brokerRemunerationDeductionGroup,
  setBrokerRemunerationDeductionGroup,
  questionnaireAnswersToDelete,
  setQuestionnaireAnswersToDelete,
}) {

  return (
    <FormSection
      sectionName="BROKER_REMUNERATION_OTHER"
      formikRef={formikRef}
      disableAll={disableAll}
      values={formikProps.values}
      errors={formikProps.errors}
      setFieldValue={formikProps.setFieldValue}
      setFieldError={formikProps.setFieldError}
      questionnaire={globalQuestionnaire}
      idOperation={idOperation}
      idOperationParent={idOperationParent}
      idProduct={idProduct}
      onQuestionChange={(
        question,
        value,
        questionnaireUpdated,
        setQuestionnaireUpdated,
        setFieldValue
      ) =>
        BrokerRemunerationOtherSection.events.handleQuestionChange({
          question,
          value,
          questionnaireUpdated,
          setQuestionnaireUpdated,
          setFieldValue,
          globalQuestionnaire,
          setShowBrokerRemunerationDeductionSection,
          brokerRemunerationDeductionGroup,
          setBrokerRemunerationDeductionGroup,
          questionnaireAnswersToDelete,
          setQuestionnaireAnswersToDelete,
        })
      }
    />
  )
}

const components = {
  RenderSection
}

export { components }